module.exports = __webpack_public_path__ + "img/9788958101611.0ee33b85.jpg";